import { useMaintenance } from "@nju/data-access-portal-technical";
import { Panel, Text } from "@nju/ui";

export function CheckSystemStatus() {
  const { orderUnavailable, paymentsUnavailable, maintenance } =
    useMaintenance();

  return (
    <div data-cy="check-system-status-section">
      <Panel iconName="server" title="sprawdź status systemu">
        <div className="flex flex-col gap-2">
          <div className="flex">
            <Text className="w-[140px] from-tablet:w-[180px] mr-2">
              app klienta
            </Text>
            <Text tone={maintenance ? "alert" : "accent"} weight="bold">
              {maintenance ? "nieaktywny" : "aktywny"}
            </Text>
          </div>
          <div className="flex">
            <Text className="w-[140px] from-tablet:w-[180px] mr-2">
              www klienta
            </Text>
            <Text tone={maintenance ? "alert" : "accent"} weight="bold">
              {maintenance ? "nieaktywny" : "aktywny"}
            </Text>
          </div>
          <div className="flex">
            <Text className="w-[140px] from-tablet:w-[180px] mr-2">
              system płatności
            </Text>
            <Text tone={paymentsUnavailable ? "alert" : "accent"} weight="bold">
              {paymentsUnavailable ? "nieaktywny" : "aktywny"}
            </Text>
          </div>
          <div className="flex">
            <Text className="w-[140px] from-tablet:w-[180px] mr-2">
              składanie zamówień
            </Text>
            <Text tone={orderUnavailable ? "alert" : "accent"} weight="bold">
              {orderUnavailable ? "nieaktywny" : "aktywny"}
            </Text>
          </div>
        </div>
      </Panel>
    </div>
  );
}
